import isNil from 'lodash/isNil'

import { OperationsReviewCategory } from '@avantstay/arriere-clients/dist/arriereBackoffice'
import { leadSourceLabel } from '@avantstay/backoffice-core'

type CategoryReview = {
  category: string
  rating?: number | null
}

type CaseBookingReview = {
  source: string
  reviewId: string
  categoryReviews: CategoryReview[]
}

export interface BookingRatingItem {
  review: CaseBookingReview
  label: string
  rating: number | undefined
}

const hasNpsOrOverallRating = (categoryReview: CategoryReview): boolean =>
  (categoryReview.category === OperationsReviewCategory.nps ||
    categoryReview.category === OperationsReviewCategory.overall) &&
  !isNil(categoryReview.rating)

const getRatingFromReview = (categoryReviews: CategoryReview[]): number | undefined => {
  const rating =
    categoryReviews.find(review => review.category === OperationsReviewCategory.nps)?.rating ??
    categoryReviews.find(review => review.category === OperationsReviewCategory.overall)?.rating

  return rating ?? undefined
}

export const getBookingRatingReviews = (
  caseBookingReviews: CaseBookingReview[] | undefined | null,
): BookingRatingItem[] => {
  if (!caseBookingReviews?.length) {
    return []
  }

  const filtered = caseBookingReviews.filter(review =>
    review.categoryReviews.some(hasNpsOrOverallRating),
  )

  return filtered.map(review => ({
    review,
    label: leadSourceLabel[review.source] ?? review.source,
    rating: getRatingFromReview(review.categoryReviews),
  }))
}

export const getBookingRatingExportValues = (
  caseBookingReviews: CaseBookingReview[] | undefined | null,
): string[] =>
  getBookingRatingReviews(caseBookingReviews).map(({ label, rating }) => `${label} • ${rating}`)
